module.exports = __webpack_public_path__ + "static/media/ArrowUp.42e6ca08.svg";